var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ComponentBase, EJComponentDecorator } from '@syncfusion/ej2-vue-base';
import { DocumentEditor } from '@syncfusion/ej2-documenteditor';
export const properties = ['acceptTab', 'currentUser', 'defaultPasteOption', 'documentEditorSettings', 'documentName', 'enableBookmarkDialog', 'enableBordersAndShadingDialog', 'enableComment', 'enableContextMenu', 'enableCursorOnReadOnly', 'enableEditor', 'enableEditorHistory', 'enableFontDialog', 'enableFormField', 'enableHyperlinkDialog', 'enableImageResizer', 'enableListDialog', 'enableLocalPaste', 'enableOptionsPane', 'enablePageSetupDialog', 'enableParagraphDialog', 'enablePersistence', 'enablePrint', 'enableRtl', 'enableSearch', 'enableSelection', 'enableSfdtExport', 'enableSpellCheck', 'enableStyleDialog', 'enableTableDialog', 'enableTableOfContentsDialog', 'enableTableOptionsDialog', 'enableTablePropertiesDialog', 'enableTextExport', 'enableTrackChanges', 'enableWordExport', 'headers', 'height', 'isReadOnly', 'layoutType', 'locale', 'pageGap', 'pageOutline', 'serverActionSettings', 'serviceUrl', 'showComments', 'showRevisions', 'useCtrlClickToFollowHyperlink', 'userColor', 'width', 'zIndex', 'zoomFactor', 'afterFormFieldFill', 'beforeFormFieldFill', 'beforePaneSwitch', 'commentBegin', 'commentDelete', 'commentEnd', 'contentChange', 'created', 'customContextMenuBeforeOpen', 'customContextMenuSelect', 'destroyed', 'documentChange', 'keyDown', 'requestNavigate', 'searchResultsChange', 'selectionChange', 'trackChange', 'viewChange', 'zoomFactorChange'];
export const modelProps = [];
/**
 * Represents the Essential JS 2 VueJS Document Editor Component
 * ```html
 * <ejs-documenteditor id='container'></ejs-documenteditor>
 * ```
 */
let DocumentEditorComponent = class DocumentEditorComponent extends ComponentBase {
    constructor() {
        super();
        this.propKeys = properties;
        this.models = modelProps;
        this.hasChildDirective = false;
        this.hasInjectedModules = true;
        this.tagMapper = {};
        this.tagNameMapper = {};
        this.ej2Instances = new DocumentEditor({});
        this.bindProperties();
        this.ej2Instances._setProperties = this.ej2Instances.setProperties;
        this.ej2Instances.setProperties = this.setProperties;
    }
    setProperties(prop, muteOnChange) {
        if (this.ej2Instances && this.ej2Instances._setProperties) {
            this.ej2Instances._setProperties(prop, muteOnChange);
        }
        if (prop && this.models && this.models.length) {
            Object.keys(prop).map((key) => {
                this.models.map((model) => {
                    if ((key === model) && !(/datasource/i.test(key))) {
                        this.$emit('update:' + key, prop[key]);
                    }
                });
            });
        }
    }
    render(createElement) {
        return createElement('div', this.$slots.default);
    }
    enableAllModules() {
        return this.ej2Instances.enableAllModules();
    }
    exportFormData() {
        return this.ej2Instances.exportFormData();
    }
    fitPage(pageFitType) {
        return this.ej2Instances.fitPage(pageFitType);
    }
    focusIn() {
        return this.ej2Instances.focusIn();
    }
    getBookmarks() {
        return this.ej2Instances.getBookmarks();
    }
    getFormFieldInfo(name) {
        return this.ej2Instances.getFormFieldInfo(name);
    }
    getFormFieldNames() {
        return this.ej2Instances.getFormFieldNames();
    }
    getStyleNames(styleType) {
        return this.ej2Instances.getStyleNames(styleType);
    }
    getStyles(styleType) {
        return this.ej2Instances.getStyles(styleType);
    }
    importFormData(formData) {
        return this.ej2Instances.importFormData(formData);
    }
    open(sfdtText) {
        return this.ej2Instances.open(sfdtText);
    }
    openBlank() {
        return this.ej2Instances.openBlank();
    }
    print(printWindow) {
        return this.ej2Instances.print(printWindow);
    }
    resetFormFields(name) {
        return this.ej2Instances.resetFormFields(name);
    }
    resize(width, height) {
        return this.ej2Instances.resize(width, height);
    }
    save(fileName, formatType) {
        return this.ej2Instances.save(fileName, formatType);
    }
    saveAsBlob(formatType) {
        return this.ej2Instances.saveAsBlob(formatType);
    }
    scrollToPage(pageNumber) {
        return this.ej2Instances.scrollToPage(pageNumber);
    }
    serialize() {
        return this.ej2Instances.serialize();
    }
    setDefaultCharacterFormat(characterFormat) {
        return this.ej2Instances.setDefaultCharacterFormat(characterFormat);
    }
    setDefaultParagraphFormat(paragraphFormat) {
        return this.ej2Instances.setDefaultParagraphFormat(paragraphFormat);
    }
    setDefaultSectionFormat(sectionFormat) {
        return this.ej2Instances.setDefaultSectionFormat(sectionFormat);
    }
    setFormFieldInfo(name, formFieldInfo) {
        return this.ej2Instances.setFormFieldInfo(name, formFieldInfo);
    }
    showDialog(dialogType) {
        return this.ej2Instances.showDialog(dialogType);
    }
    showOptionsPane() {
        return this.ej2Instances.showOptionsPane();
    }
    updateFields() {
        return this.ej2Instances.updateFields();
    }
};
DocumentEditorComponent = __decorate([
    EJComponentDecorator({
        props: properties
    })
], DocumentEditorComponent);
export { DocumentEditorComponent };
export const DocumentEditorPlugin = {
    name: 'ejs-documenteditor',
    install(Vue) {
        Vue.component(DocumentEditorPlugin.name, DocumentEditorComponent);
    }
};
